import type { DiGraph } from "./digraph.js";

/**
 * Kahn’s algorithm. Treats a positive u→v as one edge for ordering (weight ignored except sign).
 * If a cycle exists, `ok: false` and `order` lists only nodes visited before a cycle blocked completion.
 */
export function topologicalOrder(
  g: DiGraph
): { ok: true; order: string[] } | { ok: false; order: string[]; cycleHint: string } {
  const nodes = g.nodes;
  const inD = new Map<string, number>();
  for (const v of nodes) {
    let c = 0;
    for (const { w } of g.inNeighbors(v)) {
      if (w > 0) c += 1;
    }
    inD.set(v, c);
  }
  const q: string[] = [];
  for (const v of nodes) {
    if ((inD.get(v) ?? 0) === 0) q.push(v);
  }
  const order: string[] = [];
  while (q.length) {
    const u = q.shift()!;
    order.push(u);
    for (const { v, w: wt } of g.outNeighbors(u)) {
      if (wt <= 0) continue;
      inD.set(v, (inD.get(v) ?? 0) - 1);
      if (inD.get(v) === 0) q.push(v);
    }
  }
  if (order.length !== nodes.length) {
    return { ok: false, order, cycleHint: "directed cycle (or empty graph mismatch)" };
  }
  return { ok: true, order };
}
